"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildBindingIdentifier = buildBindingIdentifier;
const BindingIdentifier_1 = require("../models/BindingIdentifier");
function buildBindingIdentifier(binding) {
    return {
        [BindingIdentifier_1.bindingIdentifierSymbol]: true,
        id: binding.id,
    };
}
//# sourceMappingURL=buildBindingIdentifier.js.map